import React, { useState, useEffect, useCallback } from 'react';
import { Form, Button } from 'react-bootstrap';
import api from '../../services/api';
import moment from 'moment';
import useAuth from '../../hooks/useAuth';
// import APP_CONFIG from '../../config/appConfig';
import { Link } from 'react-router-dom';
// import './Companies.css';
import { useConfig } from '../../context/AppConfigContext';
import ScreenLoader from '../HtmlElements/ScreenLoader';
import Alert from '../HtmlElements/Alert';
import { useUser } from '../../context/UserContext';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';

const UserStats = () => {
  useAuth(); // Ensure the user is authenticated
  const { userId } = useParams();
  const { user, handleLogout } = useUser();

  const current_role_key = user?.role_key;
  const [userStats, setUserStats] = useState([]);
  const [success_message, setSuccessMessage] = useState('');
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState('companyname');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filter, setFilter] = useState({ company: '',  user: '', start_date: new Date(), end_date: new Date() });
  const [companies, setCompanies] = useState([]);
  const [users, setUsers] = useState([]);

  const [showConfirm, setShowConfirm] = useState(false);
  const [companyToDelete, setCompanyToDelete] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [showArchive, setShowArchive] = useState(0);
  const [activeTab, setActiveTab] = useState('usage_summary');
  const [usageSummary, setUsageSummary] = useState([]);
  const [usageDetails, setUsageDetails] = useState([]);
  const [userWiseAnalysis, setUserWiseAnalysis] = useState([]);
  const [monthlyAnalysis, setMonthlyAnalysis] = useState([]);
  const {appConfig} = useConfig();

  const [isMonthPicker, setMonthPicker] = useState(false);
  const [month, setMonth] = useState(new Date());

  let userList = [];

  const fetchCompanies = useCallback(async () => {
    setLoader(true);
    try {

      if(filter.is_active === ""){
        delete(filter.is_active)
      }

      const filterData = { 
        "id": '', 
        // "is_deleted": 0, 
        page: currentPage,
        limit: 1000, // All Companies
        sort_by: sortField,
        order: sortOrder,
        ...filter,
      };

      const response = await api.get('/companies/get_companies', { "params": filterData });
      let companies = [...response?.data?.result?.list];
      setCompanies(companies);

      setTotalPages(Math.ceil(response?.data?.result?.total / perPage));
  
    } catch (err) {
      setError(err.message || 'Failed to fetch companies');
    }
    setLoader(false);
  // }, [currentPage, perPage, sortField, sortOrder, filter]);
  }, []);

  useEffect(() => {
    let successMessage = sessionStorage.getItem('successMessage');
    if (successMessage) {
      setSuccessMessage(successMessage);
      sessionStorage.removeItem('successMessage'); // Clear the message
    }
    fetchCompanies();
  }, [fetchCompanies]);

// ++++++++++++++++++++++++
const fetchUsers = useCallback(async (company_id) => {
  setLoader(true);
  try {
    const response = await api.get("/users/get_users_list", {
      params: {
        company_id: company_id,
        limit: 2000
      },
    });

    if (response.status === 201 || response.status === 200) {
      userList = response?.data?.result?.list.reduce((acc, item) => {
        acc[item.id] = item.firstname+" "+item.lastname;
        return acc;
      }, {});
    }else{
      userList = [];
    }
    setUsers(userList);
    // console.log("USERLIST: "+JSON.stringify(userList));
  } catch (err) {
    setError(err.message || "Failed to fetch users");
  }
  setLoader(false);
}, []);
// ++++++++++++++++++++++++

  const fetchUserStats = useCallback(async (tab) => {
    setLoader(true);
    try {

      if(filter.is_active === ""){
        delete(filter.is_active)
      }

      const filterData = { 
        user_id: filter.user,
        company_id: filter.company,
        start_date: moment(filter.start_date).format('YYYY-MM-DD'),
        end_date: moment(filter.end_date).format('YYYY-MM-DD')
        // page: currentPage,
        // limit: perPage,
        // sort_by: sortField,
        // order: sortOrder,
        // ...filter,
      };

      let response = [];
      let user_stats = [];
      
      let user_wise_analysis = [];
      let monthly_analysis = [];
      if(tab == "usage_summary"){
        // console.log("IN USAGE SUMMARY: "+JSON.stringify(filterData));
        response = await api.get('/user_stats/get_stats_summary', {params:{
          company_id: filterData.company_id,
          start_date: filterData.start_date,
          end_date: filterData.end_date
        }});
        let usage_summary = [];
        if (response.data.status === 201 || response.data.status === 200) {
          usage_summary = response?.data?.result.list;
        }
        setUsageSummary(usage_summary);
      }else if(tab == 'usage_details'){
        response = await api.get('/user_stats/get_stats', {params:{
          user_id: filterData.user_id,
          page: currentPage,
          limit: perPage,
          company_id: filterData.company_id,
          start_date: filterData.start_date,
          end_date: filterData.end_date
        }});
        let usage_details = [];
        if (response.data.status === 201 || response.data.status === 200) {
          // usage_details = response.data.result.list;
          usage_details = (response?.data?.result?.list?.length > 0) ? response.data.result.list : [];
        }
        setUsageDetails(usage_details);
        setTotalPages(Math.ceil(response?.data?.result?.total / perPage));
        // console.log("NEW USAGE DETAILS: "+JSON.stringify(usageDetails));
      }else if(tab == 'user_wise_analysis'){
        // console.log("IN USER WISE ANALYSIS: "+JSON.stringify(filterData));
        response = await api.get('/user_stats/get_stats_analysis', {params:{
          user_id: [filterData.user_id],
          page: currentPage,
          limit: perPage,
          company_id: filterData.company_id,
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          as_excel: 0
        }});
        
        let user_wise_analysis = [];
        if (response.data.status === 201 || response.data.status === 200) {
          user_wise_analysis = response?.data?.result?.list || [];
        }
        setUserWiseAnalysis(user_wise_analysis);
        let totalUserWiseAnalysis = user_wise_analysis?.length - 1;
        setTotalPages(Math.ceil(totalUserWiseAnalysis / perPage));
      }else if(tab == 'monthly_analysis'){
        response = await api.get('/user_stats/get_stats_summary', {params:{
          user_id: [filterData.user_id],
          company_id: filterData.company_id,
          start_date: filterData.start_date,
          end_date: filterData.end_date
        }});
        if (response.data.status === 201 || response.data.status === 200) {
          monthly_analysis = response.data.result.list;
        }else{
          monthly_analysis = [];
        }
        setMonthlyAnalysis(monthly_analysis);
      }

      setUserStats(user_stats);

      setTotalPages(Math.ceil(response?.data?.result?.total / perPage));
  
    } catch (err) {
      setError('Failed to fetch stats');
    }
    setLoader(false);
  }, [currentPage, perPage, sortField, sortOrder, filter]);
  
  useEffect(() => {
    let successMessage = sessionStorage.getItem('successMessage');
    if (successMessage) {
      setSuccessMessage(successMessage);
      sessionStorage.removeItem('successMessage');
    }
    fetchUserStats();
  }, [fetchUserStats]);

  // const [users, setUsers] = useState([]);

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
  };

  const handleFilterChange = (e) => {
    setCurrentPage(1);    
    setFilter({ ...filter, [e.target.name]: e.target.value });
    if(e.target.name === "company"){
      fetchUsers(e.target.value);
    }
    /*else{
      fetchUserStats();
    }
    */
  };

  useEffect(() => {
    getDataSetTab(activeTab);
  }, [filter])

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const handleDateChange = (name, date) => {
    setFilter((prevState) => ({
      ...prevState,
      [name]: date || new Date(),
    }));

    // // Clear date-related errors
    // if (['startDate', 'startDate'].includes(name)) {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     startDate: '',
    //   }));
    // }

    // if (['contractStartDate', 'contractEndDate'].includes(name)) {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     contractEndDate: '',
    //   }));
    // }

    // Clear API error
    // setApiError('');
  };

  const getDataSetTab = (tab = "") => {
    fetchUserStats(tab);
    setActiveTab(tab);
  }

  const handleMonthChange = (month) => {
    setMonth(month);
    const enteredDate = new Date(month);
    const currentMonth = enteredDate.getMonth() + 1; // 0 for January, 11 for December
    const currentYear = enteredDate.getFullYear();
    const startDate = new Date(currentYear, currentMonth - 1, 1); // First day of the month
    const endDate = new Date(currentYear, currentMonth, 0); // Last day of the month
    setFilter((prevState) => ({
      ...prevState,
      start_date: startDate,
      end_date: endDate
    }));
  }

  useEffect(() => {
    getDataSetTab(activeTab)
  }, [currentPage])

  if(!appConfig){
    return <div> </div>;
  }

  if(current_role_key == undefined){
    return <></>
  }

  return (
    <div className="add_company_wrapper">
      {loader === true && <ScreenLoader />}
      <div className="container-fluid mt-3 p-4">
        {success_message && <Alert type="success" message={success_message} />}
        {error && <Alert type="danger" message={error} />}

        <div className="row">
          <div className="col-md-9">
            <h4 className="blue add_user_heading">User Stats Dashboard</h4>
          </div>
        </div>

        <div className="row mb-3 mt-4">
          <div className="col-md-3">
            <label htmlFor="company" className="form-label custom_label">
              Company
            </label>
            <Form.Control
              className="custom_form_control"
              as="select"
              id="company"
              key="sel-company-type"
              name="company"
              value={filter.companies}
              onChange={handleFilterChange}
            >
              <option key="select-option-company-type" value="">
                Select Company
              </option>
              {companies.map((company, index) => (
                <option key={`select-company-${company.id}`} value={company.id}>
                  {company.company_name}
                </option>
              ))}
            </Form.Control>
          </div>

          { (activeTab !== "usage_summary") && <div className="col-md-3">
            <label htmlFor="user" className="form-label custom_label">
              User/s
            </label>
            <Form.Control
              className="custom_form_control"
              as="select"
              id="user"
              key="sel-user"
              name="user"
              value={filter.user}
              onChange={handleFilterChange}
            >
              <option key="select-option-user" value="">
                Select User
              </option>
              {Object.entries(users).map(([key, value]) => (
                <option key={`select-user-${key}`} value={key}>
                  {value}
                </option>
              ))}
            </Form.Control>
          </div>}

          { (activeTab !== "monthly_analysis") && <div className="col-md-3">
            <label htmlFor="labelStartDate" className="form-label custom_label">
              Start Date
            </label>
            <DatePicker
              selected={filter.start_date}
              onChange={(date) => handleDateChange("start_date", date)}
              dateFormat="yyyy-MM-dd"
              className="form-control custom_form_control"
              id="labelStartDate"
            />
          </div>}

          { (activeTab !== "monthly_analysis") && <div className="col-md-3">
            <label htmlFor="labelEndDate" className="form-label custom_label">
              End Date
            </label>
            <DatePicker
              selected={filter.end_date}
              onChange={(date) => handleDateChange("end_date", date)}
              dateFormat="yyyy-MM-dd"
              className="form-control custom_form_control"
              id="labelEndDate"
            />
          </div>}

          { (activeTab === "monthly_analysis") && <div className="col-md-3">
            <label htmlFor="labelEndDate" className="form-label custom_label">
              Month
            </label>
            <DatePicker
              selected={month}
              onChange={(month) => {
                  // setMonthPicker(true);
                  handleMonthChange(month);
                }
              }
              showMonthYearPicker
              dateFormat="MMMM - yyyy"
              className="form-control custom_form_control"
              id="labelMonth"
            />
          </div>}

        </div>

        {/* ++++++++++++++++++++++++++++++++++++ */}
        <div className="row">
          <ul className="nav nav-tabs userStatTab">
            <li className="nav-item">
              <a
                className={`nav-link customTabLink ${activeTab == "usage_summary" ? "active" : ""}`}
                onClick={() => getDataSetTab("usage_summary")}
                aria-current="page"
                href="#xyz"
              >
                Usage Summary
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link customTabLink ${
                  activeTab == "usage_details" ? "active" : ""
                }`}
                onClick={() => getDataSetTab("usage_details")}
                aria-current="page"
                href="#"
              >
                Usage Details
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link customTabLink ${
                  activeTab == "user_wise_analysis" ? "active" : ""
                }`}
                onClick={() => getDataSetTab("user_wise_analysis")}
                aria-current="page"
                href="#"
              >
                User Wise Analysis
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link customTabLink ${
                  activeTab == "monthly_analysis" ? "active" : ""
                }`}
                onClick={() => getDataSetTab("monthly_analysis")}
                aria-current="page"
                href="#abc"
              >
                Monthly Analysis
              </a>
            </li>
          </ul>
          {/* ++++++++++++++++++++++++++++++++++++ */}
        </div>
        <div className="table-responsive pt-3">
          {(activeTab == 'usage_summary') && <table
            className="table table-striped font14 table-bordered"
            id="usage_summary"
          >
            <thead>
              <tr className="cursor_p">
                <th>Total No. of Users</th>
                <th>Total No. of Active Users</th>
                <th>Total No. of Logins</th>
                <th>Total No. of Page Hits</th>
                <th>Total No. of Accounts Viewed</th>
              </tr>
            </thead>
            <tbody>
              {<tr>
                <td>{usageSummary?.total_users}</td>
                <td>{usageSummary?.active_users}</td>
                <td>{usageSummary?.total_logins}</td>
                <td>{usageSummary?.page_hits}</td>
                <td>{usageSummary?.account_viewed}</td>
              </tr>}
            </tbody>
          </table>}
        </div>

        <div className="table-responsive">
          {(activeTab == 'usage_details') && <table
            className="table table-striped font14 table-bordered"
            id="usage_details"
          >
            <thead>
              <tr className="cursor_p">
                <th>Company Name</th>
                <th>User Name</th>
                <th>Email ID</th>
                <th>Type</th>
                <th>Action</th>
                <th>Data</th>
                <th>Timestamp</th>
                <th>Logged in IP</th>
              </tr>
            </thead>
            <tbody>
              {(usageDetails.length) ? (usageDetails.map((usage, index) => {
              return (<tr>
                <td>{usage?.company_name}</td>
                <td>{usage?.firstname+" "+usage?.lastname}</td>
                <td>{usage?.email}</td>
                <td>{usage?.type}</td>
                <td>{usage?.action}</td>
                <td>{usage?.data}</td>
                <td>{usage?.created_date}</td>
                <td>{usage?.ip_address}</td>
              </tr>)})) : (<tr>No records !</tr>)}
            </tbody>
          </table>}
        </div>

        <div className="table-responsive">
          {(activeTab == 'user_wise_analysis') && <table
            className="table table-striped font14 table-bordered"
            id="user_wise_analysis"
          >
            <thead>
              <tr className="cursor_p">
                {/* <th onClick={() => handleSort("company_name")}>
                  Client Name{" "}
                  {sortField === "company_name" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("subscription_start_date")}>
                  Start Date{" "}
                  {sortField === "subscription_start_date" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("subscription_end_date")}>
                  End Date{" "}
                  {sortField === "subscription_end_date" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("is_active")}>
                  Is Active{" "}
                  {sortField === "is_active" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                {showArchive != 1 && <th>Action</th>} */}
                <th>Company</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Total Logins</th>
                <th>Total Page hits</th>
                <th>First Login</th>
                <th>Last Login</th>
                <th>Status - Active/Inactive/Delete</th>
              </tr>
            </thead>
            <tbody>
              {(userWiseAnalysis.length) ? userWiseAnalysis.map((userWise, index) => (<tr key={`company-list-`}>
                  {/* <td>{company.company_name}</td>
                  <td>{company.subscription_start_date}</td>
                  <td>{company.subscription_end_date}</td>
                  <td>{company.is_active === 1 ? "Yes" : "No"}</td>
                  {showArchive != 1 && (
                    <td>
                      <Link
                        to={`/companies/edit_company/${company.id}`}
                        className="edit_right_margin cursor_p"
                      >
                        <span>
                          <i className="fa fa-edit blue"></i>
                        </span>
                      </Link>
                    </td>
                  )} */}
                  <td>{userWise?.company}</td>
                  <td>{userWise?.user_name}</td>
                  <td>{userWise?.email}</td>
                  <td>{userWise?.total_logins}</td>
                  <td>{userWise?.total_page_hits}</td>
                  <td>{userWise?.first_login}</td>
                  <td>{userWise?.last_login}</td>
                  <td>{userWise?.status}</td>
                </tr>)): (<tr>No records !</tr>)
              }
            </tbody>
          </table>}
        </div>

        <div className="table-responsive">
          {(activeTab == 'monthly_analysis') && <table
            className="table table-striped font14 table-bordered"
            id="monthly_analysis"
          >
            <thead>
              <tr className="cursor_p">
                <th>Parameters</th>
                <th>Value</th>
                {/* <th>Month Name</th> */}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Total Logins</td>
                <td>{monthlyAnalysis?.total_logins}</td>
              </tr>

              <tr>
                <td>Total Page Hits</td>
                <td>{monthlyAnalysis?.page_hits}</td>
              </tr>

              <tr>
                <td>Total Accounts Viewed</td>
                <td>{monthlyAnalysis?.account_viewed}</td>
              </tr>
            </tbody>
          </table>}
        </div>
        {(activeTab == "usage_details" || activeTab == "user_wise_analysis") && <nav>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button onClick={handleFirstPage} className="page-link">
                  First
                </button>
              </li>
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button onClick={handlePrevPage} className="page-link">
                  Prev
                </button>
              </li>
              {getPageNumbers().map((pageNumber) => (
                <li
                  key={pageNumber}
                  className={`page-item ${
                    pageNumber === currentPage ? "active" : ""
                  }`}
                >
                  <button
                    onClick={() => handlePageChange(pageNumber)}
                    className="page-link"
                  >
                    {pageNumber}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button onClick={handleNextPage} className="page-link">
                  Next
                </button>
              </li>
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button onClick={handleLastPage} className="page-link">
                  Last
                </button>
              </li>
            </ul>
          </nav>
        }
        
        </div>
    </div>
  );
};

export default UserStats;